import { flattenValues } from '@uniformdev/canvas';

import { CustomerDetailsStats as CustomerStat } from './customer-details-stats';

export type { CustomerDetailsStatProps as CustomerStatProps } from './customer-details-stats';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flattenCustomerStatProps = (props: any) => {
	const statProps = { ...props };
	statProps.stats = flattenValues(props.stats);
	return statProps;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UniformCustomerStat = (props: any) => {
	const statProps = flattenCustomerStatProps(props);
	return <CustomerStat {...statProps} />;
};

export default UniformCustomerStat;
